import { useState } from 'react';
import type { ValidationErrors } from '../validation';
import { emptyValidationErrors } from '../validation';

export function useValidationErrors() {
    return useState<ValidationErrors>(emptyValidationErrors);
}
